<template>
  <div class="language-select">
    <el-select
      v-model="language"
      class="input"
      @change="handleChangeLanguage"
    >
      <el-option
        v-for="option in languageOptions"
        :key="option.value"
        :value="option.value"
        :label="option.label"
      >{{ option.label }}</el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { localization } from "@/lib/mapper";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      languageOptions: [{
        value: localization.TH,
        label: 'TH'
      }, {
        value: localization.EN,
        label: 'EN'
      }, {
        value: localization.CN,
        label: 'CN'
      }],
      language: this.value
    }
  },
  methods: {
    handleChangeLanguage(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
}
</script>

<style>

</style>